import './styles/PolitiquePage.scss';

import React, { useEffect } from 'react';

import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import Wysiwyg from '../components/WysiwygComponent';
import { graphql } from 'gatsby';
import useAllPolicies from '../utils/useAllPolicies';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query PoliciesPage($cmsCode: String) {
        productsJson(code: { eq: $cmsCode }) {
            ...cmsDataFragment
        }
    }
`;
export default function PolitiquePage({
    data,
}: {
    data: Queries.PoliciesPageQuery;
}) {
    const { allPolicies } = useAllPolicies();
    const policiesArray = allPolicies.nodes;
    const { currentLocale, navigateTranslated } = usePageLocalization();
    const { t } = useTranslation('layout');
    const cms = data.productsJson;
    const metaDescriptio =
        cms?.attributes?.meta_description?.values?.[0]?.[currentLocale];
    const metaTitle = cms?.attributes?.meta_title?.values?.[0]?.[currentLocale];
    function extractPolicyPath(str: string) {
        const stringSplit = str.split('/');
        const slugUnformated = stringSplit[stringSplit.length - 1];
        const formatedPath = slugUnformated.replace('mfp-', '');
        return formatedPath;
    }

    return (
        <Layout
            breadcrumb={['Politiques', String(cms?.title?.[currentLocale])]}
            className='layout'
        >
            <SEO title={metaTitle} description={metaDescriptio} />
            <div className='politique-page-box'>
                <div className='content-box-outer-container'>
                    <h1 className='title'>{cms?.title?.[currentLocale]}</h1>
                    <div className='content-box'>
                        <Wysiwyg product={cms} />
                    </div>
                </div>
                <div className='buttons-box'>
                    <span>{t('individual-policy.title')}</span>
                    {policiesArray.map((policy, index: number) => (
                        <span
                            onClick={() => {
                                navigateTranslated(
                                    extractPolicyPath(policy?.code as string)
                                );
                            }}
                            key={index}
                            className={`${
                                policy?.title?.[currentLocale] ===
                                cms?.title?.[currentLocale]
                                    ? 'politique-button selected'
                                    : 'politique-button'
                            }`}
                        >
                            {policy?.title?.[currentLocale]}
                        </span>
                    ))}
                </div>
            </div>
        </Layout>
    );
}
